<template>
  <div>
    <div class="courses">
      <div class="container container-large">
        <div class="courses--header">
          <div class="breadcrumb"></div>
          <div class="courses--sort-options">
            <!-- <select class="form--select" data-placeholder="Sort by">
                <option value="" disabled selected>Sort by</option>
                <option value=""></option>
                <option value="1">Price dds</option>
                <option value="1">Reviews dd</option>
              </select> -->
            <div class="courses--view-option active">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  data-name="Icon awesome-align-justify"
                  d="M23.143,22.821H.857A.857.857,0,0,0,0,23.679v1.714a.857.857,0,0,0,.857.857H23.143A.857.857,0,0,0,24,25.393V23.679A.857.857,0,0,0,23.143,22.821Zm0-6.857H.857A.857.857,0,0,0,0,16.821v1.714a.857.857,0,0,0,.857.857H23.143A.857.857,0,0,0,24,18.536V16.821A.857.857,0,0,0,23.143,15.964Zm0-6.857H.857A.857.857,0,0,0,0,9.964v1.714a.857.857,0,0,0,.857.857H23.143A.857.857,0,0,0,24,11.679V9.964A.857.857,0,0,0,23.143,9.107Zm0-6.857H.857A.857.857,0,0,0,0,3.107V4.821a.857.857,0,0,0,.857.857H23.143A.857.857,0,0,0,24,4.821V3.107A.857.857,0,0,0,23.143,2.25Z"
                  transform="translate(0 -2.25)"
                  fill="#5fae32"
                ></path>
              </svg>
            </div>
            <div class="courses--view-option">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  data-name="Icon open-grid-three-up"
                  d="M0,0V6H6V0ZM9,0V6h6V0Zm9,0V6h6V0ZM0,9v6H6V9ZM9,9v6h6V9Zm9,0v6h6V9ZM0,18v6H6V18Zm9,0v6h6V18Zm9,0v6h6V18Z"
                  fill="#9f9f9f"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="courses--container">
          <div class="courses--search-box hide">
            <h3 class="courses--search-box--title">
              {{ $t("Start searching")
              }}<span class="close-search" @click="ToggleFilter">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26.004"
                  viewBox="0 0 26 26.004"
                >
                  <path
                    data-name="Union 2"
                    d="M24.994,26a1,1,0,0,1-.71-.29L13,14.424,1.715,25.714a1,1,0,0,1-.709.29,1,1,0,0,1-.71-1.71L11.58,13,.3,1.715A1,1,0,0,1,1.715.294L13,11.584,24.284.294a1,1,0,0,1,1.42,1.42L14.419,13,25.7,24.295A1,1,0,0,1,25,26Z"
                  ></path>
                </svg>
              </span>
            </h3>
            <div class="courses--search-box--content">
              <form>
                <div class="courses--filters-container">
                  <div class="courses--filters-container--title">
                    {{ $t("Date_From") }}
                  </div>
                  <v-dialog
                    ref="startDateDialog"
                    v-model="startDateModal"
                    v-bind:return-value.sync="model.dateFrom"
                    presistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="model.dateFrom"
                        v-bind:placeholder="$t('Date_From')"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="model.dateFrom" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        v-on:click="startDateModal = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        v-on:click="$refs.startDateDialog.save(model.dateFrom)"
                      >
                        Ok
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
                <div class="courses--filters-container">
                  <div class="courses--filters-container--title">
                    {{ $t("Date_To") }}
                  </div>
                  <v-dialog
                    ref="endDateDialog"
                    v-model="endDateModal"
                    v-bind:return-value.sync="model.dateTo"
                    presistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="model.dateTo"
                        v-bind:placeholder="$t('Date_To')"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="model.dateTo" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        v-on:click="endDateModal = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        v-on:click="$refs.endDateDialog.save(model.dateTo)"
                      >
                        Ok
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>

                <button
                  class="btn-round"
                  type="button"
                  @click="
                    ToggleFilter();
                    Search();
                  "
                >
                  {{ $t("Search") }}
                </button>
              </form>
            </div>
          </div>

          <div class="courses--list-wrapper">
            <ul class="webinars-status">
              <li class="webinars-status--upcoming">
                {{ $t("Upcoming") }}
              </li>
              <li class="webinars-status--running">
                {{ $t("Running") }}
              </li>
            </ul>
            <!-- <button type="button" @click="zoomMeeting">
                zoom meeting
                </button> -->
            <div
              v-if="modelList.length <= 0"
              style="margin-top: 11%; margin-left: 40%;"
            >
              {{ $t("NoHalaqa") }}
            </div>

            <div class="courses--list horizontal-view">
              <div
                class="course--box-wrapper"
                v-for="(item, findex) in modelList"
                :key="item.id"
              >
                <div class="course--box">
                  <div class="d-flex flex-column w-100 gap-3">
                    <div
                      class="d-flex flex-column gap-2 justify-content-center align-items-center"
                    >
                      <a
                        class="name"
                        href="#tutorProfilModel"
                        data-bs-toggle="modal"
                        >{{ item.title }}</a
                      >
                      <p class="text-center m-0">
                        {{ item.description }}
                      </p>
                    </div>
                    <div
                      class="d-flex w-100 justify-content-between align-items-center"
                    >
                      <a
                        class="course--box--teacher-photo"
                        href="#tutorProfilModel"
                        data-bs-toggle="modal"
                        ><img
                          v-if="item.tutor.profile_picture_url"
                          class="img-fluid"
                          :src="item.tutor.profile_picture_url"
                          :alt="findex"
                        />
                        <img
                          v-if="!item.tutor.profile_picture_url"
                          class="img-fluid"
                          src="../../public/assets/images/tutors/03.png"
                          :alt="findex"
                        />
                      </a>
                      <div class="course--box--teacher-info">
                        <p class="job">
                          {{ $t("webinar_Type")
                          }}<a href="#">{{ item.webinar_type }}</a>
                        </p>
                        <p class="job">
                          {{ $t("tutorName")
                          }}<a href="#"
                            >{{ item.tutor.first_name }}
                            {{ item.tutor.last_name }}</a
                          >
                        </p>
                        <p class="job">
                          {{ $t("language")
                          }}<a href="#">{{
                            item.tutor.languages.join(", ")
                          }}</a>
                        </p>
                        <ul>
                          <li class="info-list">
                            <span> {{ $t("Date") }} </span>
                            {{ formateDate(item.time_slot.start_date) }}
                          </li>
                        </ul>
                        <ul class="info-list">
                          <li>
                            <span> {{ $t("Start_Time") }} </span>
                            {{ item.time_slot.start_time }}
                          </li>
                          <li>
                            <span>{{ $t("End_Time") }} </span>
                            {{ item.time_slot.end_time }}
                          </li>
                        </ul>
                      </div>
                      <div class="course--box--actions">
                        <ul class="course--box--contact-options">
                          <li>
                            <!-- <span>{{ $t("status") }} </span> -->
                            <div
                              v-if="item.status == 'active'"
                              style="
                                  width: 20px;
                                  background-color:#a2f373 ;
                                  height: 20px;
                                  border-radius: 50%;
                                "
                            ></div>
                            <div
                              v-if="item.status == 'not_started'"
                              style="
                                  width: 20px;
                                  background-color: #f7f782;
                                  height: 20px;
                                  border-radius: 50%;
                                "
                            ></div>
                            <div
                              v-if="item.status == 'finished'"
                              style="
                                  width: 20px;
                                  background-color: #ed7676;
                                  height: 20px;
                                  border-radius: 50%;
                                "
                            ></div>
                          </li>
                        </ul>

                        <a
                          class="btn-round"
                          style="cursor: pointer"
                          @click="openModal(item)"
                        >
                          {{ $t(webinarButtonText) }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button class="courses--filter-btn" type="button" @click="ToggleFilter">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30.22"
          height="29.41"
          viewBox="0 0 28.22 27.41"
        >
          <path
            data-name="Path 15255"
            d="M12,30.41v-15L1.89,3H30.11L20,15.36v5.81a3,3,0,0,1-.88,2.12ZM6.11,5,14,14.64v11l3.71-3.71a1.05,1.05,0,0,0,.29-.71V14.64L25.89,5Z"
            transform="translate(-1.89 -3)"
            fill="#fff"
          ></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import moment from "moment";

export default {
  mixins: [GlobalMixin],
  data() {
    return {
      queryUrl: process.env.VUE_APP_APIEndPoint + "p2p/webinars/",
      Filter: {},
      FilterData: {},
      webinarId: "",
      AudioDocumentList: [],
      VideoDocumentList: [],
      moreClassSize: false,
      defaultShownNumber: 5,
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      startDateModal: false,
      endDateModal: false,
    };
  },
  methods: {
    // zoomMeeting() {
    //   this.$router.push({ name: "meeting",  query: {uid: 174, mid: 81850088323} });
    // },
    ToggleFilter: function() {
      jQuery(".courses--search-box").toggleClass("hide");
    },
    load: function() {
      var self = this;
      if (self.queryUrl && self.queryUrl != "") {
        self.ShowLoading();
        let today = new Date();
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = today.getFullYear();

        let date_after_month = new Date();
        date_after_month.setDate(today.getDate() + 31);
        var date_after_month_dd = String(date_after_month.getDate()).padStart(
          2,
          "0"
        );
        var date_after_month_mm = String(
          date_after_month.getMonth() + 1
        ).padStart(2, "0"); //January is 0!
        var date_after_month_yyyy = date_after_month.getFullYear();

        today = yyyy + "-" + mm + "-" + dd;
        date_after_month =
          date_after_month_yyyy +
          "-" +
          date_after_month_mm +
          "-" +
          date_after_month_dd;
        let obj = {
          from_date: self.model.dateFrom ? self.model.dateFrom : today,
          to_date: self.model.dateTo ? self.model.dateTo : date_after_month,
        };

        self.axios
          .post(self.queryUrl, obj, self.headers)
          .then(function(res) {
            self.modelList = res.data.data;
            console.log(JSON.stringify(self.modelList));

            self.afterLoad();
          })
          .catch(function(err) {
            self.displayError(err);
            return console.log(err);
          })
          .finally(function() {
            return self.HideLoading();
          });
      }
    },

    formateDate(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    },

    filterByDate: function() {
      var self = this;
      if (self.queryUrl && self.queryUrl != "") {
        self.ShowLoading();

        let obj = {
          from_date: self.model.dateFrom ? self.model.dateFrom : "",
          to_date: self.model.dateTo ? self.model.dateTo : "",
        };

        self.axios
          .post(self.queryUrl, obj, self.headers)
          .then(function(res) {
            self.modelList = res.data.data;
            console.log(self.modelList);

            self.afterLoad();
          })
          .catch(function(err) {
            self.displayError(err);
            return console.log(err);
          })
          .finally(function() {
            return self.HideLoading();
          });
      }
    },

    Search() {
      let self = this;
      self.filterByDate();
    },

    /**
     * Open login modal
     * @returns void
     */
    openLoginModal() {
      window.dispatchEvent(
        new CustomEvent("loginModalChange", {
          detail: {
            opened: true,
            tab: 0,
          },
        })
      );
    },

    openModal: function(item) {
      let self = this;
      var user = self.$store.getters.StateUser?.user; //JSON.parse(localStorage.getItem("vuex"));
      if (!user) return this.openLoginModal();
      self.webinarId = item.id;
      if (!user) {
        if (item.status == "finished") {
          self.notify(self.$t("webinarFinished"), "error");
          return;
        }
        self.notify(self.$t("webinarRegister"), "success");
        // this.$router.push({ name: "StudentRegistrationSingle" });
        this.$router.push({
          name: "StLoginforWebinar",
          params: { id: item.id },
        });
      } else if (
        user &&
        (user.category == "student" ||
          user.category == "tutor" ||
          user.category === "kids")
      ) {
        if (item.status == "finished") {
          self.notify(self.$t("webinarFinished"), "error");
          return;
        }
        // self.$router.push({ name: "meeting",  query: {uid: user.id, mid: item.zoom_meeting.response_body.id} });
        let userId = user.id;
        let uid = btoa(userId.toString());
        let meetingId = item.zoom_meeting.response_body.id;
        let mid = btoa(meetingId.toString());
        // self.$router.push({ name: "meeting", query: { uid: uid, mid: mid } });

        let subscribe = {
          user: user.id,
          webinar: self.webinarId,
        };

        self.axios
          .post(
            self.baseUrl + `p2p/webinars/${self.webinarId}/subscribed-users/`,
            subscribe,
            self.headers
          )
          .then(function(res) {
            if (res.data) {
              // if (res.data.webinar_status == "active") {
              //   window.open(res.data.join_url, "_blank");
              // } else
              if (res.data.webinar_status == "not_started") {
                // return self.notify(self.$t("RegisterWebinarSucess"), "success");
                Swal.fire({
                  icon: "success",
                  text: self.$t("RegisterWebinarSucess"),
                });
                return;
              }
              self.$router.push({
                name: "meeting",
                query: { uid: uid, mid: mid },
              });
            } else {
              self.notify(self.$t(res.data.Messages[0].Message), "error");
            }
          })
          .catch(function(err) {
            self.displayError(err);
            return console.log(err);
          })
          .finally(function() {
            return self.HideLoading();
          });

        // jQuery("#submitWebinar").modal("show");
      } else {
        self.notify(self.$t("webinarRegister"), "success");

        // this.$router.push({ name: "StudentRegistrationSingle" });
        this.$router.push({
          name: "StLoginforWebinar",
          params: { id: item.id },
        });
      }
    },
  },
  computed: {
    webinarButtonText() {
      return this.$store.getters.StateUser?.user
        ? "Join_To_Webinar"
        : "Register_To_Webinar";
    },
  },
};
</script>

<style lang="scss" scoped>
.name {
  font-size: 18px;
  color: #9f9f9f;
  line-height: 1;
  margin-bottom: 16px;
  text-decoration: none;
  display: inline-block;
  transition: all ease-in-out 0.25s;
  margin: 0;

  &:hover {
    color: #5fae32;
  }
}
</style>
